/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Avg_Score_Not_InvitedInputs */

const en_admin_statistics_avg_score_not_invited = /** @type {(inputs: Admin_Statistics_Avg_Score_Not_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avg. score (not invited)`)
};

const de_admin_statistics_avg_score_not_invited = /** @type {(inputs: Admin_Statistics_Avg_Score_Not_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ø Score (nicht eingeladen)`)
};

/**
* | output |
* | --- |
* | "Avg. score (not invited)" |
*
* @param {Admin_Statistics_Avg_Score_Not_InvitedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_avg_score_not_invited = /** @type {((inputs?: Admin_Statistics_Avg_Score_Not_InvitedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Avg_Score_Not_InvitedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_avg_score_not_invited(inputs)
	return en_admin_statistics_avg_score_not_invited(inputs)
});